// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Clear(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Clear" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M6.41217 4.99805L4.99795 6.41226L10.5858 12.0001L4.99792 17.5879L6.41214 19.0021L12 13.4143L17.5878 19.0021L19.002 17.5879L13.4142 12.0001L19.002 6.41226L17.5878 4.99805L12 10.5858L6.41217 4.99805Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Clear.js.map